import { COLOR_ORDER, FACE_ORDER } from '../core/cube-config.js';
import { CENTER_INDICES_4X4 } from '../core/cube-config-4x4.js';
import { deriveOrientation4x4 } from '../core/orientation-4x4.js';

export const SOLVER_DIAGNOSTIC_STAGE_4X4 = Object.freeze({
  UI_START: 'ui-start',
  RUNTIME_ENVIRONMENT: 'runtime-environment',
  STICKERS_READY: 'stickers-ready',
  ORIENTATION_READY: 'orientation-ready',
  WORKER_CREATED: 'worker-created',
  WORKER_CREATE_START: 'worker-create-start',
  WORKER_SCRIPT_START: 'worker-script-start',
  WORKER_READY: 'worker-ready',
  DEPENDENCY_LOAD_START: 'dependency-load-start',
  DEPENDENCY_LOAD_END: 'dependency-load-end',
  WASM_LOAD_START: 'wasm-load-start',
  WASM_LOAD_END: 'wasm-load-end',
  SOLVER_INIT_START: 'solver-init-start',
  SOLVER_INIT_END: 'solver-init-end',
  SOLVE_START: 'solve-start',
  SOLVE_END: 'solve-end',
  FALLBACK_START: 'fallback-start',
  FALLBACK_END: 'fallback-end',
  WORKER_MODULE_LOADED: 'worker-module-loaded',
  THREEPHASE_INIT_START: 'threephase-init-start',
  THREEPHASE_INIT_END: 'threephase-init-end',
  THREEPHASE_SOLVE_START: 'threephase-solve-start',
  THREEPHASE_PRECONDITION: 'threephase-precondition',
  THREEPHASE_PHASE1_START: 'threephase-phase1-start',
  THREEPHASE_PHASE1_END: 'threephase-phase1-end',
  THREEPHASE_PHASE2_START: 'threephase-phase2-start',
  THREEPHASE_PHASE2_END: 'threephase-phase2-end',
  THREEPHASE_PHASE3_START: 'threephase-phase3-start',
  THREEPHASE_PHASE3_END: 'threephase-phase3-end',
  THREEPHASE_SOLVE_END: 'threephase-solve-end',
  WORKER_RETURNED: 'worker-returned',
  CONVERT_3X3_START: 'convert-3x3-start',
  CONVERT_3X3_END: 'convert-3x3-end',
  MIN2PHASE_START: 'min2phase-start',
  MIN2PHASE_END: 'min2phase-end',
  REPLAY_START: 'replay-start',
  REPLAY_END: 'replay-end',
  WORKER_ERROR: 'worker-error',
  MESSAGE_ERROR: 'messageerror',
  UNHANDLED_REJECTION: 'unhandledrejection',
  TIMEOUT: 'timeout',
});

export const SOLVER_DIAGNOSTIC_LABEL_4X4 = Object.freeze({
  [SOLVER_DIAGNOSTIC_STAGE_4X4.UI_START]: 'UI开始求解',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.RUNTIME_ENVIRONMENT]: '运行环境与Service Worker检查完成',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.STICKERS_READY]: '96贴纸状态生成完成',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.ORIENTATION_READY]: '方向规范化完成',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_CREATED]: 'Worker创建完成',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_CREATE_START]: 'Worker创建开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_SCRIPT_START]: 'Worker脚本开始执行',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_READY]: 'Worker已就绪',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.DEPENDENCY_LOAD_START]: '依赖模块加载开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.DEPENDENCY_LOAD_END]: '依赖模块加载结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WASM_LOAD_START]: 'WASM加载检查开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WASM_LOAD_END]: 'WASM加载检查结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.SOLVER_INIT_START]: '求解器初始化开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.SOLVER_INIT_END]: '求解器初始化结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.SOLVE_START]: '求解开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.SOLVE_END]: '求解结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.FALLBACK_START]: '进入兼容回退',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.FALLBACK_END]: '兼容回退结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_MODULE_LOADED]: 'Worker模块加载完成',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_INIT_START]: 'Threephase初始化开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_INIT_END]: 'Threephase初始化结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_SOLVE_START]: 'Threephase求解开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PRECONDITION]: 'Threephase合法预处理完成',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PHASE1_START]: 'Threephase阶段1开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PHASE1_END]: 'Threephase阶段1结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PHASE2_START]: 'Threephase阶段2开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PHASE2_END]: 'Threephase阶段2结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PHASE3_START]: 'Threephase阶段3开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_PHASE3_END]: 'Threephase阶段3结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.THREEPHASE_SOLVE_END]: 'Threephase求解结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_RETURNED]: 'Worker返回主线程',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.CONVERT_3X3_START]: '3×3转换开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.CONVERT_3X3_END]: '3×3转换结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.MIN2PHASE_START]: 'min2phase开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.MIN2PHASE_END]: 'min2phase结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.REPLAY_START]: '完整公式重放验证开始',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.REPLAY_END]: '完整公式重放验证结束',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.WORKER_ERROR]: 'Worker异常',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.MESSAGE_ERROR]: 'Worker消息反序列化异常',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.UNHANDLED_REJECTION]: 'Worker未处理的Promise异常',
  [SOLVER_DIAGNOSTIC_STAGE_4X4.TIMEOUT]: '求解总超时',
});

export function createSolverDiagnostic4x4(stage, {
  source = 'main',
  startedAtMs = Date.now(),
  timestampMs = Date.now(),
  details = {},
} = {}) {
  return Object.freeze({
    stage,
    label: SOLVER_DIAGNOSTIC_LABEL_4X4[stage] ?? stage,
    source,
    timestamp: new Date(timestampMs).toISOString(),
    timestampMs,
    elapsedMs: Math.max(0, Math.round(timestampMs - startedAtMs)),
    details,
  });
}

function summarizeDetails(details) {
  const entries = Object.entries(details ?? {}).filter(([, value]) => value !== undefined);
  if (!entries.length) return '';
  return ` ${JSON.stringify(Object.fromEntries(entries))}`;
}

export function formatSolverDiagnostic4x4(event) {
  const time = event.timestamp.slice(11, 23);
  return `[${time} +${event.elapsedMs}ms][${event.source}] ${event.label}${summarizeDetails(event.details)}`;
}

export function serializeSolverError(cause, extra = {}) {
  return {
    code: cause?.code ?? extra.code ?? 'UNKNOWN_ERROR',
    name: cause?.name ?? 'Error',
    message: cause?.message ?? String(cause),
    stack: cause?.stack ?? '',
    stage: cause?.workerStage ?? extra.stage ?? null,
    resourceUrl: cause?.resourceUrl ?? extra.resourceUrl ?? null,
    ...extra,
  };
}

export function buildSolverInputDiagnostic4x4(stickers, rawOrientation, solverFacelets) {
  const orientation = rawOrientation.faceToColor ? rawOrientation : deriveOrientation4x4(rawOrientation);
  const flatColors = FACE_ORDER.flatMap((face) => stickers[face]);
  const colorCounts = Object.fromEntries(COLOR_ORDER.map((color) => [
    color,
    flatColors.filter((value) => value === color).length,
  ]));
  const colorNumbers = Object.fromEntries(COLOR_ORDER.map((color) => [
    color,
    FACE_ORDER.indexOf(orientation.colorToFace[color]),
  ]));
  const centers = Object.fromEntries(FACE_ORDER.map((face) => [face, {
    colors: CENTER_INDICES_4X4.map((index) => stickers[face][index]),
    numbers: CENTER_INDICES_4X4.map((index) => colorNumbers[stickers[face][index]]),
  }]));
  const solverFaces = Object.fromEntries(FACE_ORDER.map((face, faceIndex) => [
    face,
    solverFacelets.slice(faceIndex * 16, (faceIndex + 1) * 16).join(''),
  ]));
  return Object.freeze({
    stickerCount: flatColors.length,
    faceOrder: FACE_ORDER.join(''),
    faceLengths: Object.fromEntries(FACE_ORDER.map((face) => [face, stickers[face]?.length ?? 0])),
    colorCounts,
    colorNumbers,
    top: orientation.top,
    front: orientation.front,
    faceToColor: orientation.faceToColor,
    centers,
    solverFaceletsLength: solverFacelets.length,
    solverFaces,
    solverFacelets: [...solverFacelets],
  });
}
